export const post = {
  id: "learning-to-kickflip-matt-colbo",
  title: "Learning to Kickflip: Lessons from Matt Colbo and the Pain of Starting Something New",
  excerpt: "How a YouTube video about learning to kickflip exposed the ego traps and discomfort of being a beginner again.",
  image: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80",
  category: ["Self Improvement"],
  date: "August 27, 2021",
  readTime: 5,
  slug: "learning-to-kickflip-matt-colbo",
  content: `
I stumbled on this video by Matt Colbo: [Learning to Kickflip in a Week Using Tony Hawk's Masterclass](https://www.youtube.com/watch?v=p_bnJaKOELI). It starts out like most of his videos—funny, a bit ridiculous, and well put together. This time, he's trying to learn how to do a kickflip in just one week.

I clicked expecting entertainment. But by the end, I was hit with something surprisingly real.

---

Matt talks about how we look at people doing something impressive—like speaking a new language, doing a trick, picking up a skill—and we assume: *That doesn't look so hard. I could probably learn that too.*

But then we try. And it's *way* harder than we expected.

Suddenly, the excuses come in.

> "Maybe I'm just not built for this."
>
> "This isn't really my thing anyway."
>
> "It's not that important."

Why? Because our ego doesn't like sucking at something. Especially when we're used to being decent at most of what we do. So we retreat to the familiar—to things we're already good at—and we stay comfortable. Untested. Safe.

Matt then says something that stuck with me:

> *"I haven't tried to learn a new, actually hard, fun skill since I was thirteen."*

And he decides to push through. He's going to fall. He's going to get frustrated. His ego's going to take a hit. But he's going to do it anyway.

---

That line made me stop and ask myself:

**When was the last time I learned something new that was truly hard?**  
Something where I didn't just fail once—but failed constantly?  
Something where I had to eat the hit to my pride and still show up the next day?

We talk about growth a lot, but we don't talk enough about how much of it feels like self-inflicted humiliation. That uncomfortable process of rewiring your identity—from someone who's *never done this* into someone who *can*.

This wasn't just a kickflip video. It was a reminder of what it means to *actually* learn something.

To let go of ego.  
To be bad at something.  
To keep going anyway.

It's not just about skateboarding.

It's about anything worth getting good at.
  `
};
